import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"mt-5",attrs:{"fluid":_vm.fluid}},[_c('h1',{staticClass:"mb-3 font-weight-regular"},[_vm._v(" "+_vm._s(_vm.$t(("" + _vm.title)))+" ")]),_c(VDivider)],1)}
var staticRenderFns = []

export { render, staticRenderFns }